import { createFileRoute } from '@tanstack/react-router';
import { MyProtectedData } from '@/features/hr/MyProtectedData';

/** I miei dati particolari (art. 15 GDPR): status protetti registrati su di me + copia scaricabile. */
export const Route = createFileRoute('/_app/settings/protected-data')({ component: MyProtectedData });
